import { FormControl } from '@angular/forms';

import moment from 'moment-timezone';

export function timeValidator(control: FormControl): { time: true } | null {
  return control.value !== '' && moment(control.value, 'LT', true).isValid()
    ? null
    : { time: true };
}
